import http from '@/helpers/axios';

export function getcustomerList (data) {
  return http.request({
    url: '/homepage_admin/homepage/deepflow_customers/list',
    method: 'post',
    data
  });
}

export function getcustomerName () {
  return http.request({
    url: '/homepage_admin/homepage/deepflow_customers/names',
    method: 'get',
  });
}

export function getcustomerPhone () {
  return http.request({
    url: '/homepage_admin/homepage/deepflow_customers/phones',
    method: 'get',
  });
}